export function setSelected(state, payload) {
    state[payload.state] = payload.data;
  }